import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from '~/utils/navigation';
import useUIContext from '~/ui/use-ui-context.ts';
import { checkinPendingStatusApi } from '~/components/authentication/extended-verification/api.js';
import { showNotification } from '~/components/notifications/ducks/notifications.js';
import { selectPlayerId } from '~/components/account/ducks/index.js';
import { updateCredentials } from '~/components/authentication/ducks/index.js';
import useContextualPathTransfomer from '~/hooks/use-contextual-path-transformer.js';
import { ROUTE_ACCOUNT_COMPLETE_VERIFICATIONS } from '~/components/router/constants.js';

const useTempLoginCompleteVerifications = () => {
	const dispatch = useDispatch();
	const { withinSidebar } = useUIContext();
	const playerVerificationsVO = useSelector(state => state.account?.playerVerificationsVO);
	const playerId = useSelector(selectPlayerId);
	const router = useRouter();
	const transformPath = useContextualPathTransfomer();

	const completeVerificationDecision = useCallback(
		async (message, goBackRoute) => {
			const showThisScreens = {};
			if (goBackRoute) {
				showThisScreens.goBackRoute = goBackRoute;
			}
			const checkinResponse = await checkinPendingStatusApi(playerId);
			if (playerVerificationsVO?.mobileStatus === false) {
				showThisScreens.showPhoneVerification = true;
			}
			if (playerVerificationsVO?.checkinStatus === false) {
				showThisScreens.showExtendedVerification = true;
			}

			if (checkinResponse?.result?.pending && checkinResponse?.result?.declined === false) {
				dispatch(
					showNotification({
						message,
						color: 'neutral',
						autoHide: true,
						openInSidebar: withinSidebar
					})
				);
				showThisScreens.showExtendedVerification = false;
			}
			dispatch(updateCredentials(showThisScreens));
			router.push(transformPath(ROUTE_ACCOUNT_COMPLETE_VERIFICATIONS));
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			playerId,
			playerVerificationsVO?.checkinStatus,
			playerVerificationsVO?.mobileStatus,
			transformPath,
			withinSidebar
		]
	);

	return { completeVerificationDecision };
};

export default useTempLoginCompleteVerifications;
